import conversationCircleSvgUrl from './conversation-circle.svg';
import miniPanel1SvgUrl from './mini-panel-1.svg';
import miniPanel2SvgUrl from './mini-panel-2.svg';
import miniPanel3SvgUrl from './mini-panel-3.svg';
import miniPanel4SvgUrl from './mini-panel-4.svg';
import miniPanel5SvgUrl from './mini-panel-5.svg';

import dashboardSvgUrl from './icons/dashboard.svg';
import inboxSvgUrl from './icons/inbox.svg';
import myWebsiteSvgUrl from './icons/my-website.svg';
import marketingSvgUrl from './icons/marketing.svg';
import paymentsSvgUrl from './icons/payments.svg';
import insightsSvgUrl from './icons/insights.svg';
import supportSvgUrl from './icons/support.svg';
import settingsSvgUrl from './icons/settings.svg';
import leadOverviewSvgUrl from './icons/lead-overview.svg';
import leadsSvgUrl from './icons/leads.svg';
import conversationsSvgUrl from './icons/conversations.svg';
import appointmentsSvgUrl from './icons/appointments.svg';
import contactsSvgUrl from './icons/contacts.svg';
import smsBlastsSvgUrl from './icons/sms-blasts.svg';
import emailBlastsSvgUrl from './icons/email-blasts.svg';
import automationsSvgUrl from './icons/automations.svg';
import socialMediaSvgUrl from './icons/social-media.svg';
import reputationSvgUrl from './icons/reputation.svg';
import siteAnalyticsSvgUrl from './icons/site-analytics.svg';
import adReportingSvgUrl from './icons/ad-reporting.svg';
import leadReportingSvgUrl from './icons/lead-reporting.svg';
import keywordTrackingSvgUrl from './icons/keyword-tracking.svg';
import callTrackingSvgUrl from './icons/call-tracking.svg';
import localTrackingSvgUrl from './icons/local-tracking.svg';
import aiTrackingSvgUrl from './icons/ai-tracking.svg';
import myProfileSvgUrl from './icons/my-profile.svg';
import billingSvgUrl from './icons/billing.svg';
import businessInfoSvgUrl from './icons/business-info.svg';
import calendarSettingsSvgUrl from './icons/calendar-settings.svg';
import crmSettingsSvgUrl from './icons/crm-settings.svg';
import logOutSvgUrl from './icons/log-out.svg';
import remindersSvgUrl from './icons/reminders.svg';
import qrCode from './icons/qr-code.svg';
import chatWidget from "./icons/chat-widget.svg";
import sendBlast from './icons/send-blast.svg';
import trafficSvgUrl from './icons/traffic.svg';
import leadsInsightSvgUrl from './icons/leads-insight.svg';
import visibilitySvgUrl from './icons/visibility.svg';
const CONVERSATION_CIRCLE_SELECTOR =
  'img[src="https://appcdn.leadconnectorhq.com/crm/conversations-components/788/images/circles.svg"]';

const MINI_PANEL_SVG_URLS = [
  miniPanel1SvgUrl,
  miniPanel2SvgUrl,
  miniPanel3SvgUrl,
  miniPanel4SvgUrl,
  miniPanel5SvgUrl,
];

const ICON_SVG_URLS = {
  DASHBOARD: dashboardSvgUrl,
  INBOX: inboxSvgUrl,
  MY_WEBSITE: myWebsiteSvgUrl,
  MARKETING: marketingSvgUrl,
  PAYMENTS: paymentsSvgUrl,
  INSIGHTS: insightsSvgUrl,
  SUPPORT: supportSvgUrl,
  SETTINGS: settingsSvgUrl,
  LEAD_OVERVIEW: leadOverviewSvgUrl,
  LEADS: leadsSvgUrl,
  CONVERSATIONS: conversationsSvgUrl,
  APPOINTMENTS: appointmentsSvgUrl,
  CONTACTS: contactsSvgUrl,
  SMS_BLASTS: smsBlastsSvgUrl,
  EMAIL_BLASTS: emailBlastsSvgUrl,
  AUTOMATIONS: automationsSvgUrl,
  SOCIAL_MEDIA: socialMediaSvgUrl,
  REPUTATION: reputationSvgUrl,
  SITE_ANALYTICS: siteAnalyticsSvgUrl,
  AD_REPORTING: adReportingSvgUrl,
  LEAD_REPORTING: leadReportingSvgUrl,
  KEYWORD_TRACKING: keywordTrackingSvgUrl,
  CALL_TRACKING: callTrackingSvgUrl,
  LOCAL_TRACKING: localTrackingSvgUrl,
  AI_TRACKING: aiTrackingSvgUrl,
  MY_PROFILE: myProfileSvgUrl,
  BILLING: billingSvgUrl,
  BUSINESS_INFO: businessInfoSvgUrl,
  CALENDAR_SETTINGS: calendarSettingsSvgUrl,
  CRM_SETTINGS: crmSettingsSvgUrl,
  LOG_OUT: logOutSvgUrl,
  REMINDERS: remindersSvgUrl,
	QR_CODE: qrCode,
	CHAT_WIDGET: chatWidget,
	SEND_BLAST: sendBlast,
	TRAFFIC: trafficSvgUrl,
  LEADS_INSIGHT: leadsInsightSvgUrl,
  VISIBILITY: visibilitySvgUrl,
  DIGITAL_ADS: adReportingSvgUrl,
  CALL_REPORT: callTrackingSvgUrl,
};

const ICON_KEYS = Object.keys(ICON_SVG_URLS);
const PROD_ASSET_BASE = 'https://ghl.influx.mx/';

let conversationCircleSvgMarkup = '';
const miniPanelSvgMarkup = [];
let svgLoadPromise = null;

export const ICONS = Object.fromEntries(ICON_KEYS.map((key) => [key, '']));

function resolveAssetUrl(url) {
  const isLocalHost =
    typeof window !== 'undefined' &&
    /^(localhost|127\.0\.0\.1)$/i.test(window.location?.hostname || '');

  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  const base =
    (typeof window !== 'undefined' && window.__influxstyles_base) ||
    (typeof window !== 'undefined' && window.__ghlAssetBase) ||
    (typeof window !== 'undefined' && (isLocalHost ? window.location?.origin : PROD_ASSET_BASE)) ||
    '';

  if (!base) {
    return url;
  }

  try {
    return new URL(url, base).toString();
  } catch (_error) {
    return url;
  }
}

function fetchSvgMarkup(url) {
  return fetch(url, { cache: 'force-cache', credentials: 'omit' }).then((response) => {
    if (!response.ok) {
      throw new Error(`Failed to fetch SVG ${url}: ${response.status}`);
    }
    return response.text();
  });
}

function markAssetsReady() {
  window.__ghlSvgAssetsReadyVersion = Date.now();
}

export function preloadSvgAssets() {
  if (svgLoadPromise) {
    return svgLoadPromise;
  }

  svgLoadPromise = Promise.all([
    fetchSvgMarkup(resolveAssetUrl(conversationCircleSvgUrl)),
    ...MINI_PANEL_SVG_URLS.map((url) => fetchSvgMarkup(resolveAssetUrl(url))),
    ...ICON_KEYS.map((key) => fetchSvgMarkup(resolveAssetUrl(ICON_SVG_URLS[key]))),
  ])
    .then(([conversationSvg, ...rest]) => {
      const miniPanelSvgs = rest.slice(0, MINI_PANEL_SVG_URLS.length);
      const iconSvgs = rest.slice(MINI_PANEL_SVG_URLS.length);

      conversationCircleSvgMarkup = conversationSvg.trim();

      miniPanelSvgMarkup.length = 0;
      miniPanelSvgMarkup.push(...miniPanelSvgs.map((svg) => svg.trim()));

      ICON_KEYS.forEach((key, index) => {
        ICONS[key] = iconSvgs[index]?.trim() || '';
      });

      markAssetsReady();
    })
    .catch((error) => {
      console.error('[GHL Build] Failed to preload SVG assets', error);
    });

  return svgLoadPromise;
}

export function replaceConversationCircleSVGs(root = document) {
  if (!conversationCircleSvgMarkup) {
    preloadSvgAssets();
    return;
  }

  root.querySelectorAll(CONVERSATION_CIRCLE_SELECTOR).forEach((img) => {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = conversationCircleSvgMarkup;
    img.replaceWith(wrapper.firstElementChild);
  });
}

export function replaceMiniPanelSVGs(root = document) {
  if (miniPanelSvgMarkup.length === 0) {
    preloadSvgAssets();
    return;
  }

  const svgs = root.querySelectorAll('.mini-panel svg');
  miniPanelSvgMarkup.forEach((markup, index) => {
    if (svgs.length > index) {
      svgs[index].outerHTML = markup;
    }
  });
}
